export enum DebitAmountType {
  Dollar,
  Percent
}